import { type ReactNode, useState } from 'react';

import { 
  FillButton,
  Modal, 
  ModalActions, 
  ModalContent, 
  ModalToolbar, 
  OutlineButton
} from '@recargas-dominicanas/core/components';

import { type Style, mergeStyle } from './confirm-modal.module.css';

interface Props {
  open: boolean;
  title: string;
  description?: string;
  style?: Style;
  children?: ReactNode;
  disableConfirmation?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function ConfirmModal(props: Props) {

  const {
    open,
    title,
    description,
    disableConfirmation,
    style: customStyle,
    children,
    onConfirm,
    onClose
  } = props;

  const style = mergeStyle(customStyle);
  const [check, setCheck] = useState(disableConfirmation);

  async function handleConfirm() {
    onConfirm();
    handleClose();
  }

  function handleClose() {
    setCheck(disableConfirmation);
    onClose();
  }

  style.modal = { card: `${style.modal.card} ${customStyle?.card}` };

  return (
    <Modal 
      open={open}
      style={style.modal}
      onClose={handleClose}>
      <ModalToolbar 
        title={title}
        style={style.toolbar}
        onClose={handleClose}/>
      <ModalContent>
        <div className={style.content}>
          {children}
        </div>
        {!disableConfirmation &&
          <label className={style.label}>
            <input
              type='checkbox' 
              checked={check}
              className={style.checkbox}
              onChange={() => setCheck(check => !check)}/>
            {description}
          </label>
        }
      </ModalContent>
      <ModalActions>
        <OutlineButton 
          text='Cancelar'
          onClick={handleClose}/>
        <FillButton 
          text='Aceptar' 
          disabled={!check}
          onClick={handleConfirm}/>
      </ModalActions>
    </Modal>
  );
}
